import React, { useEffect, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import supabase from '../supabaseClient';

const AuthCallback = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo') || '/app/home';

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the session from Supabase
        const { data: { session }, error: authError } = await supabase.auth.getSession();
        
        if (authError) {
          throw new Error(authError.message || 'Failed to get session');
        }

        if (!session) {
          throw new Error('No active session found. Please try signing in again.');
        }

        // Store the session in localStorage for persistence
        localStorage.setItem('supabase.auth.token', session.access_token);
        
      } catch (error) {
        console.error('Authentication error:', error);
        setError(error.message || 'An unexpected error occurred during authentication');
      } finally {
        setLoading(false);
      }
    };

    handleAuthCallback();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-700">Completing authentication...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="bg-white p-6 rounded-lg shadow-md max-w-md w-full">
          <div className="text-red-500 text-4xl mb-4 text-center">⚠️</div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Authentication Error</h2>
          <p className="text-gray-600 mb-6">{error}</p>
          <div className="flex justify-center">
            <a
              href="/login"
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md transition-colors"
            >
              Return to Login
            </a>
          </div>
        </div>
      </div>
    );
  }

  // If no error and not loading, redirect to the intended destination
  return <Navigate to={returnTo} replace />;
};

export default AuthCallback;